import { NO_PATTERN_BUSINESS_LOGIC, Price } from '@vfde-brix/core';
import {
    createFeatureTileComponent,
    FeatureTile,
} from '@vfde-brix/feature-tile';
import { StateProps } from 'app/container/DeviceDetail/interfaces/state';

/**
 * Mount the Feature Tile
 * @param container
 * @param onChange
 */
const mountFeatureTile = (containerId: string, onChange: (event: Event, checked: boolean) => void): FeatureTile => {
    const containerElement = document.getElementById(containerId) as HTMLElement;

    return containerElement && createFeatureTileComponent(containerElement, {
        onChange,
    });
};

/**
 * Update Insurance Feature Tile
 * @param featureTile
 * @param insurance
 * @param isHardwareOnly
 */
export const updateInsuranceFeatureTile = (featureTile: FeatureTile, {offer, hasInsurance, isHardwareOnly}: Partial<StateProps>) => {
    // We have to get the feature tile properties here and update it because the promoPrice is nested
    const properties = featureTile.getProperties();

    if (offer?.insurance?.price.gross) {
        properties.promoPrice = properties.promoPrice || {
            price: null!, // set below
            business: NO_PATTERN_BUSINESS_LOGIC,
        };

        properties.promoPrice.price = Price.fromNumber(offer.insurance.price.gross);
    }

    properties.optChecked = hasInsurance && !isHardwareOnly;
    properties.optDisabled = isHardwareOnly;

    featureTile.update(properties);
};

export default mountFeatureTile;
